import React, { useEffect, useState } from 'react';
import IBAN from 'iban';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTheme } from '@mui/material/styles';
import { useViewports } from '../../../hooks/useViewports';
import CopiedTooltip from '../CopiedTooltip';
import CopyIbanIcon from '../Icons/CopyIban';
import { copyHandler } from '../utils';
import * as S from './styles';
const AUTO_HIDE_DURATION = 3000;
const UserSection = ({ fullName, accountIds, isDropdownOpen }) => {
    const theme = useTheme();
    const { isMobile } = useViewports(theme);
    const [openedId, setOpenedId] = useState();
    const clickHandler = (id) => {
        copyHandler(IBAN.isValid(id) ? IBAN.electronicFormat(id) : id);
        setOpenedId(id);
    };
    useEffect(() => {
        let timer;
        if (openedId) {
            timer = setTimeout(() => {
                setOpenedId(undefined);
            }, AUTO_HIDE_DURATION);
        }
        return () => clearTimeout(timer);
    }, [openedId]);
    useEffect(() => {
        if (!isDropdownOpen) {
            setOpenedId(undefined);
        }
    }, [isDropdownOpen]);
    return (React.createElement(S.Wrapper, null,
        React.createElement(S.Container, null,
            React.createElement(S.FullName, null, fullName),
            accountIds.map(({ id, label }) => (React.createElement(S.AccountWrapper, { key: id },
                label && React.createElement(S.AccountLabel, null, label),
                id && (React.createElement(S.AccountId, { role: "menuitem", tabIndex: -1, onKeyDown: (e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            clickHandler(id);
                        }
                    } },
                    React.createElement(S.Iban, null, IBAN.isValid(id) ? IBAN.printFormat(id, ' ') : id),
                    React.createElement(CopiedTooltip, { title: React.createElement(CheckCircleOutlineIcon, null), placement: "top", open: isMobile ? openedId === id : openedId === id && isDropdownOpen, arrow: true },
                        React.createElement(S.CopyIconButton, { onClick: () => clickHandler(id), endIcon: React.createElement(CopyIbanIcon, null), "aria-label": `Copy IBAN ${id}` }))))))))));
};
export default UserSection;
//# sourceMappingURL=index.js.map